<template>
  <div class="upload-choose">
    <!-- 选择上传方式 -->
    <iModal
      footer-hide
      :styles="{top: '300px'}"
      width="400px"
      @on-visible-change="chooseClose"
      :value="showed"
      :z-index="1100"
    >
      <div style="display:flex;justify-content:space-around;margin:50px">
        <div class="uploadBox" @click="chooseClose();materialShowed()">
          <i class="icon iconfont icon-sucaiku1" style="font-size:60px"></i>
          Material liberary
        </div>
        <div class="uploadBox" @click="chooseClose();$emit('upload:local')">
          <i class="icon iconfont icon-bendishangchuan" style="font-size:60px"></i>
          本地上传
        </div>
      </div>
    </iModal>

    <!-- 素材库上传 -->
    <iModal
      :styles="{top: '50px'}"
      width="800px"
      title="Material liberary"
      v-model="dialogShowed"
      :z-index="1100"
    >
      <Row :gutter="16" style="height:720px;">
        <Col
          span="8"
          v-for="(item,index) in list"
          :key="index"
          @click.native="selected(index,item)"
          style="cursor:pointer;margin-bottom:10px;position:relative;"
        >
          <div class="select">
            <!-- {{item.selected}} -->
            <img v-if="fileType=='img'" :src="item.src" :alt="item.name" />
            <img v-if="fileType=='video'" :src="item.src" :alt="item.name" />
            <!-- <video
              :src="item.videoInfo|getPath"
              controls="controls"
              v-if="fileType=='video'"
            >您的浏览器不支持 video 标签。</video>-->
            <div :class="item.selected?item.selected: 'selected1'">
              <i
                class="icon iconfont icon-chenggong"
                style="position:absolute;left:50%;top:50%;font-size:50px;color:#fff;margin-left:-25px;margin-top:-37.5px;"
              ></i>
            </div>
          </div>
        </Col>
      </Row>
      <div class="my-page" v-if="totalCount > pageSize">
        <Page
          show-total
          show-elevator
          :page-size="pageSize"
          :current="pageIndex"
          :total="totalCount"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </div>
      <div slot="footer" style="text-align:center">
        <Button type="primary" @click="materialClose()">确定</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  model: {
    prop: "showed",
    event: "change"
  },
  props: {
    showed: Boolean,
    fileType: String,
    maxCount: Number
  },
  data() {
    return {
      dialogShowed: false,
      list: [],
      selectList: [],

      pageSize: 12,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    listC() {
      return this.list;
    },
    ...mapGetters({
      company: "loginModule/getCompany",
      material: "materialModule/getMaterial",
      videoMaterial: "materialModule/getVideoMaterial"
    }),
    query() {
      return {
        CompId: this.company.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };
    }
  },
  methods: {
    ...mapActions("materialModule", ["getMaterial", "getvideoMaterial"]),
    chooseClose(e) {
      this.$emit("change", e);
    },
    materialClose() {
      this.dialogShowed = false;
      this.$emit("upload:material", this.selectList);
    },
    setItem(item) {
      switch (this.fileType) {
        case "img":
          return {
            name: item.name,
            src: item.path,
            path: item.path
          };
        case "video":
          let info = JSON.parse(item.videoInfo);
          return {
            name: item.name,
            src: info.Img,
            path: info.Link
          };
        default:
          break;
      }
    },
    setList(x) {
      let items = x.items;
      this.list = [];
      for (const item of items) {
        let temp = this.setItem(item);
        if (this.selectList.indexOf(temp.path) > -1) {
          temp.selected = "selected2";
        }
        this.list.push(temp);
      }
      this.totalCount = x.totalCount;
      this.pageSize = x.pageSize;
      this.pageIndex = x.pageIndex;
    },
    refushList() {
      switch (this.fileType) {
        case "img":
          this.getMaterial(this.query).then(x => {
            this.setList(x);
          });
          break;
        case "video":
          this.getvideoMaterial(this.query).then(x => {
            console.error("------", x);
            this.setList(x);
          });
          break;
      }
    },
    materialShowed() {
      this.dialogShowed = true;
      this.selectList = [];
      this.refushList();
    },
    selected(i, item) {
      if (item.selected) {
        delete item.selected;
        this.selectList.splice(this.selectList.indexOf(item.path), 1);
      } else if (this.selectList.length < this.maxCount) {
        item.selected = "selected2";
        this.selectList.push(item.path);
      } else {
        this.$Notice.warning({
          title: "文件数量是超过限制",
          desc: `当前可上传文件最大数量为:${this.maxCount}`
        });
      }
      this.$set(this.list, i, item);
    },
    changePage(e) {
      this.pageIndex = e;
      this.refushList();
    },
    changePageSize(e) {
      this.pageSize = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.uploadBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120px;
  height: 120px;
  border-radius: 5px;
  color: #808080;
  font-weight: bold;
  &:hover {
    background-color: #e6ecf2;
    color: #1890ff;
    cursor: pointer;
  }
}
.select {
  width: 100%;
  height: 100%;
  padding-bottom: 66.666667%;
  display: inline-block;
  position: relative;
  // background-color: #1890ff;
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
  video {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
  .selected1 {
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    position: absolute;
    background-color: rgba(145, 145, 146, 0);
    i {
      opacity: 0;
    }
  }
  .selected2 {
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    position: absolute;
    background-color: rgba(145, 145, 146, 0.6);
    i {
      opacity: 1;
    }
  }
}
.my-page {
  height: 50px;
  padding: 10px;
}
</style>